package com.meistercharts.charts.pv.modulePlanning

import com.meistercharts.charts.pv.roofPlanning.Module

/**
 * How a single [Module] is highlighted on top of the roof during module planning.
 */
enum class ModuleHighlight {
  /**
   * No highlight - the module image alone is painted.
   */
  None,

  /**
   * The module overlaps another module. This is a warning about the model, not about what the mouse is doing.
   */
  Overlapping,

  /**
   * The mouse is over the module or over another module of the same module area.
   */
  Hover,

  /**
   * The module area the module belongs to is being dragged.
   */
  Dragging,

  /**
   * Releasing the mouse deletes the module.
   */
  DeleteArmed,

  /**
   * Releasing the mouse restores the previously deleted module.
   */
  UndeleteArmed,
}
